import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { useQueryParams } from '@hooks/queryParams';
import { ResourcesUsersRespSuccess } from './types';
import { camelToSnakeCase } from '@utils/textHelpers';
import {
  getActive,
  RESOURCES_PHONE_PEOPLE_TYPES,
  useResourcesPhoneView,
  useResourceType,
} from '../helpers';
import { usePanel } from '@hooks/usePanel';
import { useParams } from 'react-router';
import { filterDeactivatedCrewMembersFromCrew } from './helpers';

export const useGetResourcesUsers = () => {
  const {
    params: { search, status, sort: sortingValue, direction: sortingDirection, people },
    parseParams,
  } = useQueryParams();
  const { panel } = usePanel();
  const { tenantId } = useParams();
  const type = useResourceType();
  const phoneView = useResourcesPhoneView();
  const phoneTypes = people ? [camelToSnakeCase(people)] : RESOURCES_PHONE_PEOPLE_TYPES;
  const isPeople = phoneView ? phoneView === 'people' : type !== 'equipment';

  const queryParams = parseParams(
    {
      type: phoneView ? phoneTypes : camelToSnakeCase(type || ''),
      search,
      active: getActive(status || []),
      sortingValue: phoneView ? 'last_name' : sortingValue || 'roles',
      sortingDirection: phoneView ? 'asc' : sortingDirection || 'asc',
    },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending } = useQuery<ResourcesUsersRespSuccess, ApiError>({
    queryKey: [...queryKeys.resources.users, queryParams],
    queryFn: () =>
      queryFetch({
        url: [panel ? `tenants/${tenantId}/` : '', `resources/users${queryParams}`].join(''),
        panel,
      }),
    placeholderData: (previousData) => previousData as ResourcesUsersRespSuccess,
    enabled: isPeople,
    select: (resp) => ({
      ...resp,
      records: filterDeactivatedCrewMembersFromCrew(resp.records),
    }),
  });

  return {
    data,
    error,
    isLoading: isPending && isPeople,
  };
};
